const items = [
  "Lake Eufaula · Bass Capital of the World",
  "Historic Shorter Mansion",
  "Southern Cuisine",
  "Eufaula National Wildlife Refuge",
  "Book Direct by Phone",
];

export const Marquee = () => {
  const row = [...items, ...items];
  return (
    <div className="bg-[#C5A059] py-4 overflow-hidden border-y border-[#0A192F]/15" data-testid="editorial-marquee">
      <div className="marquee-track flex whitespace-nowrap w-max">
        {row.map((item, i) => (
          <span key={i} className="flex items-center text-[#0A192F] font-serif-display text-lg sm:text-xl font-semibold tracking-wide">
            <span className="px-6">{item}</span>
            <span className="text-[#0A192F]/50">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};
